<script lang="ts" setup>
    import { computed, ref, type PropType } from 'vue'
    import ArticleCard from '@/components/ArticleCard.vue';
    interface Catalog {
        title: string;
        cover_image: string;
        seo_name: string;
        external_link: string;
    }
    let props = defineProps({
        catalogs: {
            type: Array as PropType<Catalog[]>,
            required: true,
            default(){
                return []
            }
        }
    })


</script>
<template>
    <div class="plp">
        <div class="filter-bar">
        </div>
        <div class="container-filter-product-grid">
            <div class="overlay"></div>
            <div class="product-grid-container">
                <div class="product-grid blog-grid">
                    <ArticleCard :link="catalog.external_link" v-for="(catalog, index) of catalogs" :headline="catalog.title" :image="`https://www.rothco.com//upload/catalogs//${catalog.cover_image}`" :key="index" external/>
                </div>
         
            </div>
        </div>
    </div>
</template>
